import { checkBrowserSupport } from 'utils/browser';

checkBrowserSupport();
